import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { MenuStateService } from "../../services/menu-state.service";
import { UserInfoService } from "../../services/user-info.service";
import { filter, Subscription, switchMap } from "rxjs";
import { UserDataService } from "../../pages/user-list/services/user-data.service";
import { NotificationDataService } from "../../pages/notifications/services/notification-data.service";
import { AuthService } from "../../services/auth/auth.service";
import { NavigationEnd, Router } from "@angular/router";

@Component({
	selector: "app-menu",
	templateUrl: "./menu.component.html",
	styleUrls: ["./menu.component.scss"],
})
export class MenuComponent implements OnInit, OnDestroy, AfterViewInit {
	@Input() isSmallMenu = false;
	@Output() isSmallMenuChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	subs: Subscription[] = [];

	fistLetterName = "";

	constructor(
		private menuStateService: MenuStateService,
		private userInfoService: UserInfoService,
		private userDataService: UserDataService,
		private notificationDataService: NotificationDataService,
		private authService: AuthService,
		private router: Router
	) {}

	ngOnInit() {
		this.subs.push(
			this.userInfoService.userInfo$.subscribe({
				next: (res) => {
					if (res) {
						this.fistLetterName = res.full_name.substring(0, 1);
					}
				},
			})
		);

		this.initCountRequest();
	}

	ngOnDestroy() {
		this.subs.forEach((item) => item.unsubscribe());
	}

	ngAfterViewInit() {
		this.initUserName();
	}

	initUserName() {
		setTimeout(() => {
			if (this.authService.getToken()) {
				const userId = localStorage.getItem("user_id") ?? "";
				this.userDataService.loadUserInfo(+userId).subscribe({
					next: (res) => {
						this.userInfoService.userInfo$.next(res);
					},
				});
			}
		}, 100);
	}

	initCountRequest() {
		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				switchMap(() => this.authService.isAuth$),
				filter((isAuthenticated) => isAuthenticated),
				switchMap(() => this.notificationDataService.loadCount())
			)
			.subscribe({
				next: (res) => {
					if (res) {
						this.userInfoService.userNotificationCount$.next(res.unread_count);
					}
				},
			});
	}

	toggleMenu() {
		this.isSmallMenu = !this.isSmallMenu;
		this.isSmallMenuChange.emit(this.isSmallMenu);
		this.menuStateService.menuState$.next(this.isSmallMenu);
	}
}
